import PaymentQRCode from "./PaymentQRCode";

function InvoicePrint({ order, settings }) {
  return (
    <div style={{ width: "280px", fontSize: "12px", fontFamily: "monospace" }}>
      {/* Store Header */}
      <h3 style={{ textAlign: "center" }}>{order.storeName}</h3>
      <p style={{ textAlign: "center" }}>{order.storeAddress}</p>
      <hr />

      {/* Order Details */}
      <p>Invoice #: {order.invoiceNo}</p>
      <p>Date: {order.date}</p>
      <p>Cashier: {order.cashier}</p>
      <hr />

      {/* Items */}
      {order.items.map((item) => (
        <div key={item.id} style={{ display: "flex", justifyContent: "space-between" }}>
          <span>{item.name} x {item.qty}</span>
          <span>{item.amount}</span>
        </div>
      ))}
      <hr />

      {/* Totals */}
      <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" }}>
        <span>Total</span>
        <span>{order.total}</span>
      </div>

      {/* Footer Message */}
      <p style={{ textAlign: "center", marginTop: 10 }}>Thank you for visiting!</p>

      <PaymentQRCode upiId="yourupi@upi" amount={order.total} />
    </div>
  );
}

export default InvoicePrint;
